/* IQ Pouch cart drawer controls (snippets/cart-drawer.liquid).
   The drawer's regions are swapped with innerHTML after every cart change, so
   everything here is delegated from document and reads state from the JSON
   the snippet renders into each region, never from memory. */
(function () {
  if (window.__ddCartDrawerBound) return;
  window.__ddCartDrawerBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_STEPS = 20;
  /* Same safety rail as the bbx-recons stepper: at most 20 units of a pack. */
  var MAX_QTY = 20;

  function readJson(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not update your cart. Please try again.');
        return data;
      });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function cartState(scope) {
    var el = scope.querySelector('[data-dd-cart-state]');
    var state = el ? readJson(el) : null;
    return state || { addPlan: null, eligible: ',' };
  }

  function isEligible(state, variantId) {
    return state.eligible.indexOf(',' + variantId + ',') !== -1;
  }

  function linePlan(i) {
    return i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null;
  }

  /* STOQ owns the preorder plan when it is loaded; the Liquid-resolved plan is the fallback,
     the same order bbx-recons uses when it adds a preorder. */
  function preorderPlan(variant) {
    var rr = window._RestockRocket;
    if (rr && typeof rr.getSellingPlan === 'function') {
      try {
        var plan = rr.getSellingPlan(variant.id);
        if (plan && plan.shopify_selling_plan_id) return Number(plan.shopify_selling_plan_id);
      } catch (e) {}
    }
    return variant.poPlan ? Number(variant.poPlan) : null;
  }

  /* planId is the flavor's subscription plan, or null for one-time. */
  function lineItem(flavor, variant, quantity, planId) {
    var item = { id: variant.id, quantity: quantity };
    if (variant.po) {
      var po = preorderPlan(variant);
      if (po) item.selling_plan = po;
    } else if (planId && variant.sub && flavor.plans.indexOf(planId) !== -1) {
      item.selling_plan = planId;
    }
    return item;
  }

  function refresh() {
    if (window.eventBus) window.eventBus.emit('render:cart:drawer');
    fetch(root + 'cart?view=compare')
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (window.wetheme && window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart); })
      .catch(function () {});
  }

  function run(scope, task) {
    var body = scope.querySelector('[data-dd-cd]');
    var error = scope.querySelector('[data-dd-cd-error]');
    if (body) body.classList.add('is-busy');
    if (error) error.textContent = '';
    return task()
      .catch(function (err) {
        if (error) error.textContent = err.message || 'Could not update your cart. Please try again.';
      })
      .then(function () {
        if (body) body.classList.remove('is-busy');
        refresh();
      });
  }

  function zeroOut(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return post('cart/update.js', { updates: updates });
  }

  /* The bbx-recons stepper, counted in cans: 1-Can units up to 4, then whole
     5-Can packs (5, 10, 15 ...) so the quantity stays on the tiered pack discount.
     Returns null when the step takes the flavor to 0, which removes it. */
  function stepTarget(flavor, dir) {
    var one = flavor.variants.find(function (v) { return v.cans === 1; });
    var five = flavor.variants.find(function (v) { return v.cans === 5; });
    var cans = flavor.cans;
    var next;

    if (dir > 0) {
      if (cans < 4 || !five) next = cans + 1;
      else if (cans < 5) next = 5;
      else next = (Math.floor(cans / 5) + 1) * 5;
    } else {
      if (cans <= 1) return null;
      if (cans <= 5 || !five) next = cans - 1;
      else next = (Math.ceil(cans / 5) - 1) * 5;
      if (!one && next < 5) return null;
    }

    if (next >= 5 && five) {
      return { variant: five, quantity: Math.min(next / 5, MAX_QTY) };
    }
    if (!one) return null;
    return { variant: one, quantity: Math.min(next, MAX_QTY) };
  }

  /* Leaves exactly one line for the flavor: target variant × quantity on planId. */
  function setFlavorQuantity(flavor, target, planId) {
    var wanted = lineItem(flavor, target.variant, target.quantity, planId);

    function matches(i) {
      return i.variant_id === wanted.id && linePlan(i) === (wanted.selling_plan || null);
    }

    /* STOQ re-keys preorder lines when another preorder is added, so keys are only
       trusted from a cart read after the add. */
    function removeRest() {
      return getCart().then(function (cart) {
        var lines = cart.items.filter(function (i) { return i.product_id === flavor.productId; });
        var keep = lines.find(function (i) { return matches(i) && i.quantity === target.quantity; }) || lines.find(matches);
        return zeroOut(lines.filter(function (i) { return i !== keep; }).map(function (i) { return i.key; }));
      });
    }

    return getCart().then(function (cart) {
      var keep = cart.items.find(function (i) { return i.product_id === flavor.productId && matches(i); });
      if (keep) {
        return post('cart/change.js', { id: keep.key, quantity: target.quantity }).then(removeRest);
      }
      /* Add first so a failed add never leaves the flavor removed. */
      return post('cart/add.js', { items: [wanted] }).then(removeRest);
    });
  }

  function removeFlavor(flavor) {
    return getCart().then(function (cart) {
      return zeroOut(cart.items
        .filter(function (i) { return i.product_id === flavor.productId; })
        .map(function (i) { return i.key; }));
    });
  }

  function stepFlavor(flavor, dir) {
    var target = stepTarget(flavor, dir);
    if (!target) return dir < 0 ? removeFlavor(flavor) : Promise.resolve();
    return setFlavorQuantity(flavor, target, flavor.plan);
  }

  function addFlavor(flavor, state) {
    var one = flavor.variants.find(function (v) { return v.cans === 1; }) || flavor.variants[0];
    if (!one) return Promise.resolve();
    return post('cart/add.js', { items: [lineItem(flavor, one, 1, state.addPlan)] });
  }

  /* Moves this flavor's subscribable lines to planId (null = one-time). /cart/change can
     merge lines and re-key them, so each step works from the cart the previous step returned. */
  function setFlavorPlan(flavor, planId, state) {
    function step(cart, count) {
      if (count > MAX_STEPS) return Promise.resolve();
      var next = cart.items.find(function (i) {
        if (i.product_id !== flavor.productId || !isEligible(state, i.variant_id)) return false;
        return linePlan(i) !== planId;
      });
      if (!next) return Promise.resolve();
      return post('cart/change.js', { id: next.key, quantity: next.quantity, selling_plan: planId })
        .then(function (updated) { return step(updated, count + 1); });
    }
    return getCart().then(function (cart) { return step(cart, 0); });
  }

  function flavorFrom(el) {
    var row = el.closest('[data-dd-flavor]');
    var json = row && row.querySelector('[data-dd-flavor-json]');
    return json ? readJson(json) : null;
  }

  function selectedPlan(el, flavor) {
    var row = el.closest('[data-dd-flavor]');
    var select = row && row.querySelector('[data-dd-every]');
    var value = select ? Number(select.value) : NaN;
    return value || flavor.plan || flavor.defaultPlan;
  }

  document.addEventListener('click', function (e) {
    var scope = e.target.closest('cart-drawer');
    if (!scope) return;
    var state = cartState(scope);
    var el, flavor;

    if ((el = e.target.closest('[data-dd-step]'))) {
      e.preventDefault();
      flavor = flavorFrom(el);
      var dir = Number(el.getAttribute('data-dd-step'));
      if (flavor) run(scope, function () { return stepFlavor(flavor, dir); });
      return;
    }
    if ((el = e.target.closest('[data-dd-mode]'))) {
      e.preventDefault();
      if (el.getAttribute('aria-checked') === 'true') return;
      flavor = flavorFrom(el);
      if (!flavor) return;
      var plan = el.getAttribute('data-dd-mode') === 'sub' ? selectedPlan(el, flavor) : null;
      run(scope, function () { return setFlavorPlan(flavor, plan, state); });
      return;
    }
    if ((el = e.target.closest('[data-dd-remove-key]'))) {
      e.preventDefault();
      var key = el.getAttribute('data-dd-remove-key');
      run(scope, function () { return zeroOut([key]); });
      return;
    }
    if ((el = e.target.closest('[data-dd-add]'))) {
      e.preventDefault();
      flavor = flavorFrom(el);
      if (flavor) run(scope, function () { return addFlavor(flavor, state); });
    }
  });

  /* Picking a frequency subscribes the flavor on that plan, from one-time too. */
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('cart-drawer [data-dd-every]');
    if (!select) return;
    var scope = select.closest('cart-drawer');
    var flavor = flavorFrom(select);
    var plan = Number(select.value);
    if (!flavor || !plan || flavor.plan === plan) return;
    run(scope, function () { return setFlavorPlan(flavor, plan, cartState(scope)); });
  });
})();
